import createIcon from '../../createIcon';

/**
 * @component @name LocationCity
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTEuNVY1LjVMMTIgMi41TDkgNS41VjcuNUgzVjIxLjVIMjFWMTEuNUgxNVpNNyAxOS41SDVWMTcuNUg3VjE5LjVaTTcgMTUuNUg1VjEzLjVIN1YxNS41Wk03IDExLjVINVY5LjVIN1YxMS41Wk0xMyAxOS41SDExVjE3LjVIMTNWMTkuNVpNMTMgMTUuNUgxMVYxMy41SDEzVjE1LjVaTTEzIDExLjVIMTFWOS41SDEzVjExLjVaTTEzIDcuNUgxMVY1LjVIMTNWNy41Wk0xOSAxOS41SDE3VjE3LjVIMTlWMTkuNVpNMTkgMTUuNUgxN1YxMy41SDE5VjE1LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocationCity = createIcon('LocationCity', [
  [
    'path',
    {
      d: 'M15 11.5V5.5L12 2.5L9 5.5V7.5H3V21.5H21V11.5H15ZM7 19.5H5V17.5H7V19.5ZM7 15.5H5V13.5H7V15.5ZM7 11.5H5V9.5H7V11.5ZM13 19.5H11V17.5H13V19.5ZM13 15.5H11V13.5H13V15.5ZM13 11.5H11V9.5H13V11.5ZM13 7.5H11V5.5H13V7.5ZM19 19.5H17V17.5H19V19.5ZM19 15.5H17V13.5H19V15.5Z',
      key: '3dtah0',
    },
  ],
]);

export default LocationCity;
